<template>
  <div
    ref='root'
    v-show='visible'
    class='popup upload'
    :class='{ dragging: isDragging }'
    :style='{ backgroundImage: "url(" + bg + ")"}'
    @dragover.prevent='onDragOver($event)'
    @dragleave.prevent='onDragLeave($event)'
    @drop.prevent='onDrop($event)'
  >
    <div
      class='content'
      :style='{ backgroundImage: "url(" + border + ")"}'
    >
      <span class='header'>Upload file</span>
      <div class='main'>
        <span>Drag & Drop</span>
        <span style='font-size: 18px'>or</span>
        <a @click='onLoad'>
          Select file
        </a>
      </div>
    </div>
    <div class='close'>
      <a @click='onClose'>
        <img src='@/assets/images/ui/close.png' />
      </a>
    </div>
  </div>
</template>

<script>

import PopupBase from './PopupBase.vue';
import bg from '@/assets/images/ui/drag-and-drop.png';
import border from '@/assets/images/ui/dot-border.png';
import FileTypes from '../assets/javascripts/FileTypes';

export default {
  name: 'UploadPopup',
  extends: PopupBase,
  components: {
  },
  props: {
  },
  computed: {
  },
  data () {
    return {
      isDragging: false,
      bg: bg,
      border: border
    };
  },
  mounted () {
  },
  methods: {
    read (file) {
      const separated = file.name.split('.');
      const ext = separated[separated.length - 1];

      const reader = new FileReader();
      reader.onloadend = (evt) => {
        switch (ext) {
          case 'json':
          case 'JSON':
            {
              const json = JSON.parse(reader.result);
              this.$emit('parse', FileTypes.PATH, json, file, file.name);
            }
            break;

          case 'ghx':
          case 'GHX':
            const parser = new DOMParser();
            const dom = parser.parseFromString(reader.result, 'application/xml');
            this.$emit('parse', FileTypes.GHX, dom, file, file.name);
            break;

          case 'dxf':
          case 'DXF':
            this.$emit('parse', FileTypes.DXF, reader.result, file, file.name);
            break;

          case 'path':
          case 'PATH':
            const pathJson = JSON.parse(reader.result);
            this.$emit('parse', FileTypes.PATH, pathJson, file, file.name);
            break;

          case 'ply':
          case 'PLY':
            this.$emit('parse', FileTypes.PLY, reader.result);
            break;
        }

        this.onClose();
      };

      switch (ext) {
        case 'ply':
        case 'PLY':
          reader.readAsArrayBuffer(file);
          break;
        default:
          reader.readAsText(file);
          break;
      }
    },
    onLoad () {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.ghx,.json,.dxf,.ply';
      input.onchange = (evt) => {
        if (evt.target.files.length > 0) {
          this.read(evt.target.files[0]);
        }
      };
      input.click();
    },
    onDragOver (e) {
      this.isDragging = true;
    },
    onDragLeave (e) {
      this.isDragging = false;
    },
    onDrop (e) {
      let files = e.target.files ? e.target.files : e.dataTransfer.files;
      if (files.length > 0) {
        let file = files[0];
        this.read(file);
      }
      this.isDragging = false;
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/UploadPopup.vue